import { FactoryArg } from "imask";
import { MaskedInputProps, MaskedInputControlledProps, MaskedInput, MaskedInputControlled } from "./MaskedInput";

const mask = "000-00-0000";
const validationExp = /\d{3}-\d{2}-\d{4}/;
const placeholder = "123-45-6789";
const validationMessage = "Invalid Social Security Number";

export const MaskedSsnInput = <Opts extends FactoryArg>(props: Partial<MaskedInputProps<Opts>>) => {
    return <MaskedInput type="tel" placeholder={placeholder} mask={mask} {...props} />;
};

export const MaskedSsnInputControlled = <Opts extends FactoryArg>({
    name,
    rules,
    invalidMessage,
    ...props
}: { invalidMessage?: string; name: string } & Partial<MaskedInputControlledProps<Opts>>) => {
    return (
        <MaskedInputControlled
            name={name}
            type="tel"
            placeholder={placeholder}
            mask={mask}
            rules={{ pattern: { value: validationExp, message: invalidMessage || validationMessage }, ...rules }}
            {...props}
        />
    );
};
